'use es6';

import { Record } from 'immutable';
import { BiddingStrategyType } from '../../lib/Constants';
export default Record({
  biddingStrategyId: null,
  biddingStrategyName: null,
  biddingStrategyType: BiddingStrategyType.MANUAL_CPC,
  maxCpcBid: null,
  biddingStrategySource: null,
  targetCpa: null,
  targetRoas: null,
  targetSpend: null
});